import { render, staticRenderFns } from "./CurrenciesForm.vue?vue&type=template&id=77de7f09"
import script from "./CurrenciesForm.vue?vue&type=script&lang=js"
export * from "./CurrenciesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports